import { SubscriptionParamsData, SubscriptionParamsQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export class SubscriptionParams extends LongList<
    SubscriptionParamsData,
    SubscriptionParamsData,
    SubscriptionParamsQuery
> {
    public static Name = 'subscriptionParams' as const;

    protected create(params: SubscriptionParamsData): SubscriptionParamsData {
        return params;
    }
}

export const subscriptionParams = new SubscriptionParams();
